import { ReactElement } from 'react'
import { useFormContext } from 'react-hook-form'
import { Stack } from '@mui/material'
import { ImmutableVector3 } from '@modugen/ui-toolkit'
import { CoordinatePointInput } from '@ui/forms'
import { useModelStore } from '@editorStores'
import { useStoreSubscription } from '@editorHooks'

const FormFields = (): ReactElement => {
  const updateColumn = useModelStore(state => state.updateColumn)
  const { setValue, getValues } = useFormContext()
  const storeyBoundaries = useModelStore(state => state.model.storey_boundaries)
  useStoreSubscription({
    writeCallback: ({ guid, shape: { start, end } }) => {
      updateColumn({
        guid,
        shape: {
          start: new ImmutableVector3(Number(start.x), Number(start.y), Number(start.z)),
          end: new ImmutableVector3(Number(start.x), Number(start.y), Number(end.z)),
        },
      })
    },
  })

  const handleReplace = (x: number, y: number) => {
    const storey = getValues('storey')
    const storeyLowerZ = storeyBoundaries[storey][0]
    const storeyUpperZ = storeyBoundaries[storey][1]
    setValue('shape.start.x', x)
    setValue('shape.start.y', y)
    setValue('shape.end.x', x)
    setValue('shape.end.y', y)
    setValue('shape.start.z', storeyLowerZ)
    setValue('shape.end.z', storeyUpperZ)
  }

  return (
    <Stack direction="column" spacing={1}>
      <CoordinatePointInput
        label="Start"
        name="shape.start"
        pointManipulation={{
          x: { roundOnReplace: true },
          y: { roundOnReplace: true },
          z: { roundOnReplace: false },
        }}
        onChangeX={value => {
          setValue('shape.end.x', value)
          setValue('shape.start.x', value)
        }}
        onChangeY={value => {
          setValue('shape.end.y', value)
          setValue('shape.start.y', value)
        }}
        onReplace={handleReplace}
      />
      <CoordinatePointInput
        label="Ende"
        name="shape.end"
        pointManipulation={{
          x: { roundOnReplace: true },
          y: { roundOnReplace: true },
          z: { roundOnReplace: false },
        }}
        onChangeX={value => {
          setValue('shape.start.x', value)
          setValue('shape.end.x', value)
        }}
        onChangeY={value => {
          setValue('shape.start.y', value)
          setValue('shape.end.y', value)
        }}
        onReplace={handleReplace}
      />
    </Stack>
  )
}

export default FormFields
